module.exports = __webpack_public_path__ + "img/Cdiscount.1363644d.jpg";